import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset, isOpen, onToggle }) => {
  const categoryOptions = [
    { value: 'all', label: 'Semua Motor' },
    { value: 'Matic', label: 'Motor Matic' },
    { value: 'Bebek', label: 'Motor Bebek' },
    { value: 'Sport', label: 'Motor Sport' },
    { value: 'EV', label: 'Motor EV' }
  ];


  const engineOptions = [
    { value: 'all', label: 'Semua Kapasitas' },
    { value: '110-125', label: '110-125cc' },
    { value: '150-160', label: '150-160cc' },
    { value: '250-300', label: '250-300cc' },
    { value: '500+', label: '500cc+' }
  ];

  const transmissionOptions = [
    { value: 'all', label: 'Semua Transmisi' },
    { value: 'Otomatis', label: 'Otomatis' },
    { value: 'Manual', label: 'Manual' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Terbaru' },
    { value: 'price-low', label: 'Harga Terendah' },
    { value: 'price-high', label: 'Harga Tertinggi' },
    { value: 'popular', label: 'Terpopuler' },
    { value: 'name', label: 'Nama A-Z' }
  ];

  return (
    <>
      <div className="lg:hidden mb-4">
        <Button
          variant="outline"
          fullWidth
          iconName={isOpen ? 'X' : 'SlidersHorizontal'}
          iconPosition="left"
          onClick={onToggle}
        >
          {isOpen ? 'Tutup Filter' : 'Tampilkan Filter'}
        </Button>
      </div>
      <div className={`bg-card rounded-xl shadow-card-hover p-4 md:p-6 ${
        isOpen ? 'block' : 'hidden lg:block'
      }`}>
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-heading font-bold text-foreground flex items-center space-x-2">
            <Icon name="SlidersHorizontal" size={20} color="var(--color-primary)" />
            <span>Filter Motor</span>
          </h3>
          <Button
            variant="ghost"
            size="sm"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onReset}
          >
            Reset
          </Button>
        </div>

        <div className="space-y-4">
          <Input
            label="Cari Motor"
            type="search"
            placeholder="Cari nama motor..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="mb-4"
          />

          <Select
            label="Kategori"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange('category', value)}
          />

          <Select
            label="Kapasitas Mesin"
            options={engineOptions}
            value={filters?.engineSize}
            onChange={(value) => onFilterChange('engineSize', value)}
          />

          <Select
            label="Transmisi"
            options={transmissionOptions}
            value={filters?.transmission}
            onChange={(value) => onFilterChange('transmission', value)}
          />

          <div>
            <label className="block text-sm font-heading font-semibold text-foreground mb-3">
              Rentang Harga
            </label>
            <div className="space-y-3">
              <Input
                type="number"
                placeholder="Harga Minimum"
                value={filters?.priceMin}
                onChange={(e) => onFilterChange('priceMin', e?.target?.value)}
              />
              <Input
                type="number"
                placeholder="Harga Maksimum"
                value={filters?.priceMax}
                onChange={(e) => onFilterChange('priceMax', e?.target?.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-heading font-semibold text-foreground mb-3">
              Konsumsi BBM (km/liter)
            </label>
            <div className="space-y-3">
              <Input
                type="number"
                placeholder="Minimum"
                value={filters?.fuelMin}
                onChange={(e) => onFilterChange('fuelMin', e?.target?.value)}
              />
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <Select
              label="Urutkan"
              options={sortOptions}
              value={filters?.sortBy}
              onChange={(value) => onFilterChange('sortBy', value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;